import { createFileRoute } from "@tanstack/react-router";
import AirCompressorSubcategoryLanding from "@/pages/AirCompressorSubcategoryLanding";

export const Route = createFileRoute("/air-compressors/category/$slug")({
  component: AirCompressorSubcategoryLanding,
});
